import { API_ROUTES } from '@config/routes';
import api from './api';

export interface SubmitSupportFeedbackPayload {
  category: SupportFeedbackCategory;
  subject: string;
  message: string;
}

export interface UpdateSupportFeedbackStatusPayload {
  status: 'pending' | 'rejected';
}

export interface ReplyToSupportFeedbackPayload {
  customerReply: string;
}

export type SupportFeedbackStatus = 'pending' | 'in-progress' | 'completed' | 'rejected';
export type SupportFeedbackCategory =
  | 'billing'
  | 'technical-issue'
  | 'feature-request'
  | 'bug-report'
  | 'account-issue'
  | 'general-inquiry';

export const SUPPORT_FEEDBACK_CATEGORY_OPTIONS: Array<{
  value: SupportFeedbackCategory;
  label: string;
}> = [
  { value: 'billing', label: 'Billing' },
  { value: 'technical-issue', label: 'Technical issue' },
  { value: 'feature-request', label: 'Feature request' },
  { value: 'bug-report', label: 'Bug report' },
  { value: 'account-issue', label: 'Account issue' },
  { value: 'general-inquiry', label: 'General inquiry' },
];

export interface SupportFeedbackSubmission {
  id: string;
  category: SupportFeedbackCategory;
  subject: string;
  message: string;
  source: string;
  sourceApp: string;
  userId: string;
  userEmail: string;
  userName: string;
  accountName: string | null;
  subscriptionPlan: string | null;
  status: SupportFeedbackStatus;
  response: string;
  responseUpdatedAt: string | null;
  customerReply: string;
  customerReplyUpdatedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SupportFeedbackStatusUpdateResult {
  id: string;
  status: SupportFeedbackStatus;
  updatedAt: string;
}

export interface SupportFeedbackReplyUpdateResult {
  id: string;
  customerReply: string;
  customerReplyUpdatedAt: string | null;
  updatedAt: string;
}

export const submitSupportFeedback = (payload: SubmitSupportFeedbackPayload) =>
  api.post<SupportFeedbackSubmission>(API_ROUTES.SUPPORT.FEEDBACK, payload);

export const fetchSupportFeedback = () =>
  api.get<SupportFeedbackSubmission[]>(API_ROUTES.SUPPORT.FEEDBACK);

export const updateSupportFeedbackStatus = (
  id: string,
  payload: UpdateSupportFeedbackStatusPayload
) => api.patch<SupportFeedbackStatusUpdateResult>(API_ROUTES.SUPPORT.FEEDBACK_BY_ID(id), payload);

export const replyToSupportFeedback = (id: string, payload: ReplyToSupportFeedbackPayload) =>
  api.patch<SupportFeedbackReplyUpdateResult>(API_ROUTES.SUPPORT.FEEDBACK_BY_ID(id), payload);
